import React from 'react';

import { Helpers } from '../../core/src/helpers';
import Accordion from '../../shared/components/accordion';
import ProductPrice from '../../product/components/product-price';

import '../css/pdp-learn-more.less';

const BASE_PRODUCT = {
    name: "Standard Warranty",
    price: "Included with device",
    duration: "1 year",
    compSupport: true,
    twentyFourSeven: false,
    accidental: false,
    lojack: false,
    monitor: false,
    riskFree: false,
    sku: 'default'
};

const ROWS = [
    {
        title: "Coverage Plan",
        key: "name"
    }, {
        title: "Price",
        key: "price"
    }, {
        title: "Total years of hardware coverage",
        tip: "From date of purchase.",
        key: "duration"
    }, {
        title: "Initial setup & software support",
        tip: "We provide initial setup support and a team to assist you with HP purchased software.",
        check: true,
        key: "compSupport"
    }, {
        title: "24/7 Support",
        tip: "Get support from professionals who know HP products best - anytime you need.",
        check: true,
        key: "twentyFourSeven"
    }, {
        title: "Monitor coverage",
        tip: "Includes protection for your monitor too!",
        check: true,
        key: "monitor",
        footnote: "When Monitor is purchased together with a desktop PC."
    }, {
        title: "Accidental Damage Protection",
        tip: "Protection starts as soon as your product ships and covers accidental drops, spills, cracked screens, and more. Available only on select HP Care Packs.",
        check: true,
        key: "accidental"
    }, {
        title: "Anti-theft protection (LoJack)",
        tip: "If your device gets lost or stolen, we can lock your device, track it, and work with authorities to help recover it. We can also wipe your hard drive so your private information stays private. Available only on select HP Care Packs.",
        check: true,
        key: "lojack"
    }, {
        title: "Risk free rebate eligible",
        check: true,
        link: {
            label: "Learn more",
            href: `${process.env.BASENAME}/ContentView?eSpotName=Risk-Free-Care-Pack&storeId=10151&catalogId=10051&langId=-1&jumpid=020116_PDPModal`
        },
        key: "riskFree"
    }
]

const EMPTY_OBJECT = {};
const EMPTY_ARRAY = [];

class LearnMore extends React.Component {

    selectCarePack = (product) => {
        const { handleDefaultClick, handleClick, closeModal } = this.props;
        if(product.sku === 'default' && handleDefaultClick) handleDefaultClick();
        else{
            const bundleIndex = this.getBundleIndex(product.sku);
            handleClick(bundleIndex);
        }
        closeModal();
    }

    getBundleIndex = (sku) => {
        const { bundles, products } = this.props; 
        if(sku === 'default')return null;
        if(bundles){
            return this.props.bundles.find(bundle=> sku === bundle.products[0].sku).bundleIndex;
        }
        return products && products.findIndex(p => p.sku === sku);
    }

    getCarePacks = Helpers.memoize((sku) =>{
        const { defaultCarePack=EMPTY_OBJECT } = this.props.customConfig;
        const duration = Helpers.getCarepackDuration(defaultCarePack.name);
        if (duration) {
            BASE_PRODUCT.duration = `${duration} year${parseInt(duration) > 1 ? 's' : ''}`;
        }
        const baseProduct = Object.assign({}, BASE_PRODUCT, defaultCarePack);
        return [baseProduct].concat(this.props.products);
    });

    render() {
        const { defaultSelected, selectionMap, customConfig, sku, selectedCarepack } = this.props;
        const { carePackModal=EMPTY_OBJECT, disclaimers=EMPTY_ARRAY } = customConfig;
        const carePacks = this.getCarePacks(sku);
        return (
            <div className={`learn-more-modal${carePackModal.classes ? ` ${carePackModal.classes}` : ''}`}>
                <h1 className='learn-more-header'>HP's got your back</h1>
                <div className='learn-more-sub'>
                    {carePackModal.subHeader ? carePackModal.subHeader : 'Be Prepared for anything. Enhance and extend your protection beyond the standard limited warranty with an HP Care Pack.'}
                </div>
                <table>
                    <tbody>
                        {ROWS.map((row, i) => (
                            carePacks.some(product => product[row.key]) &&
                            <tr key={i}>
                                <td>
                                    {row.tip ? <Accordion title={row.title}>{row.tip}</Accordion> : <div className={`learn-more-${row.key}`}>{row.title}</div>}
                                    {row.link && <a className='learn-more-link' href={row.link.href} target='_blank'>{row.link.label}</a>}
                                </td>
                                {
                                    carePacks.map(
                                        product => row.check ?
                                        <td key={product.sku} className={product[row.key] ? 'checked' : undefined}></td> :
                                        <td key={product.sku}>{i === 0 && <div className='title-duration'>{product.duration}</div>}{
                                             row.key === 'price' && product.price !== 'Included with device' ?
                                             <ProductPrice product={product}/> : product[row.key]
                                        }</td>
                                    )
                                }
                            </tr>
                        ))}
                        <tr className='learn-more-select'>
                            <td></td>
                            {
                                carePacks.map( (product, i) => {
                                    const bundleIndex =  this.getBundleIndex(product.sku);
                                    return(
                                        <td key={product.sku}>
                                            <div>
                                            {
                                                (defaultSelected && i === 0 || selectionMap[bundleIndex]) ||
                                                (selectedCarepack && selectedCarepack.sku === product.sku) ?
                                                <div>{defaultSelected && i === 0  ? 'Included' : 'Selected'}</div> :
                                                <div className='learn-more-option' onClick={() => this.selectCarePack(product)}>Select</div>
                                            }
                                            </div>
                                        </td>
                                    )
                                })
                            }
                        </tr>
                    </tbody>
                </table>
                <ul className='learn-more-disclaimers'>
                {
                    disclaimers.map((disclaimer, key)=>
                        <li key={`disclaimer-${key}`} className='learn-more-disclaimer'>
                            {disclaimer}
                        </li>
                    )
                }
                </ul>
            </div>
        )
    }

}

export default LearnMore;
